import { combineReducers } from 'redux';

import algolia_filters from './modules/algolia_filters';
import algolia_tracking_context from './modules/algolia_tracking_context';
import appSettings from './modules/appSettings';
import auth from './modules/auth';
import banner from './modules/banner';
import chargebee from './modules/chargebee';
import confirmation from './modules/confirmation';
import editorialPlaylist from './modules/editorialPlaylist';
import forgotPassword from './modules/forgotPassword';
import kinkinessScore from './modules/kinkinessScore';
import onboarding from './modules/onboarding';
import onboarding_responses from './modules/onboarding_responses';
import onboardingPlaylist from './modules/onboardingPlaylist';
import pin from './modules/pin';
import player from './modules/player';
import playlist from './modules/playlist';
import postPurchase from './modules/postPurchase';
import profile from './modules/profile';
import promoCountdownBanner from './modules/promoCountdownBanner';
import queue from './modules/queue';
import quizManager from './modules/quizManager';
import recommendationsCampaigns from './modules/recommendationsCampaigns';
import search from './modules/search';
import setNewPassword from './modules/setNewPassword';
import signIn from './modules/signIn';
import signUp from './modules/signUp';
import translations from './modules/translations';
import userAlreadyListenedStories from './modules/userAlreadyListenedStories';

const rootReducer = combineReducers({
  algolia_filters,
  algolia_tracking_context,
  appSettings,
  auth,
  banner,
  chargebee,
  confirmation,
  editorialPlaylist,
  forgotPassword,
  kinkinessScore,
  onboarding_responses,
  onboarding,
  onboardingPlaylist,
  pin,
  player,
  playlist,
  postPurchase,
  profile,
  promoCountdownBanner,
  queue,
  quizManager,
  recommendationsCampaigns,
  search,
  setNewPassword,
  signIn,
  signUp,
  translations,
  userAlreadyListenedStories,
});

export default rootReducer;
